<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="
        bg-primary 
        text-white 
        border-0 
        font-weight-bold 
        p-3"
    >Data Peserta Pelatihan {{ this.title_tab }}
     <!-- <CButton color="info" class="btn-md ml-auto">Ekspor Excel</CButton> -->
    
    </CCardHeader>
    <!-- Tabs -->
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/pelatihan/data-peserta-pelatihan/Webinar"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('Webinar')"
          aria-controls="Webinar"
          aria-selected="true">Webinar</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/pelatihan/data-peserta-pelatihan/lms"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('LMS')"
          aria-controls="home"
          aria-selected="true">LMS</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/pelatihan/data-peserta-pelatihan/offline"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="tabchange('Offline')"
          aria-controls="profile"
          aria-selected="false">Offline</router-link>
      </li>
    </ul>

    <!-- Data RPL-->
    <router-view></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>
<script>

export default {
  data() {
    return {
        title_tab : 'LMS',
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  watch: {
    
  },
  methods: {
      tabchange(value) {
          this.title_tab = value;
          switch (value) {
            case 'LMS':
                break;
            case 'Webinar':
                break;
            case 'Offline':
                break;
              default:
                  break;
          }
      },
      mountedchange(value) {
        switch (value) {
            case '/pelatihan/data-peserta-pelatihan/lms':
                this.title_tab = 'LMS';
                break;
            case '/pelatihan/data-peserta-pelatihan/Webinar':
                this.title_tab = 'Webinar';
                break;
            case '/pelatihan/data-peserta-pelatihan/offline':
                this.title_tab = 'Offline';
                break;
            default:
                break;
        }
      }
  }
};
</script>